import * as ActionTypes from 'state/types'

const initialState = {
  isRequesting: false,
  isFailure: false,
  all: null,
  assigned: null,
  archived: null,
  inboxesSum: null,
  inboxes: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ActionTypes.COUNTERS_LIST_REQUEST}_START`: {
      return {
        ...state,
        isRequesting: true,
        isFailure: false
      }
    }

    case `${ActionTypes.COUNTERS_LIST_REQUEST}_SUCCESS`: {
      const {
        counters
      } = action.response.payload

      return {
        ...state,
        isRequesting: false,
        isFailure: false,
        all: counters.all,
        assigned: counters.assigned,
        archived: counters.archived,
        inboxesSum: counters.inboxesSum,
        inboxes: counters.inboxes
      }
    }

    case ActionTypes.COUNTERS_UPDATED: {
      const {
        counters
      } = action.payload


      return {
        ...state,
        ...counters
      }
    }

    case `${ActionTypes.COUNTERS_LIST_REQUEST}_FAIL`: {
      return {
        ...state,
        isRequesting: false,
        isFailure: true
      }
    }
    default:
      return state
  }
}
